import PromoCardParent from "../../Components/PromoCardParent/PromoCardParent";
import PartnerPromoSection from "../../Components/PromoPartnerParent/PromoPartnerParent";
import ChefsSection from "./sections/ChefsSection";
import FoodTypeSection from "./sections/FoodTypeSection";
import HomeFAQ from "./sections/HomeFAQ";
import InstantFoods from "./sections/InstantFoods";
import Kitchens from "./sections/Kitchens";
import OfferFoods from "./sections/OfferFoods";
import PreOrderFoods from "./sections/PreOrderFoods";
import ReadyMadeFoods from "./sections/ReadyMadeFoods";
import Recipes from "./sections/Recipes";

export default function Home() {
  return (
    <>
      <FoodTypeSection />
      <PromoCardParent />
      <PartnerPromoSection />
      <OfferFoods />
      <PreOrderFoods />
      <InstantFoods />
      <ReadyMadeFoods />
      <Recipes title="Offer Recipes" />
      <Kitchens />
      <ChefsSection />
      {/* <Catering /> */}
      <HomeFAQ />
    </>
  );
};
